<div class="content-wrapper d-print-none">
    <div class="row">
        <div class="col-lg-12 grid-margin stretch-card">
            <div class="card">
                <div class="card-body">
                    <h4 class="card-title">New Express Approval </h4>
                    <form class="form"  #ngNewExpressForm="ngForm" name="form"
                    (ngSubmit)="ngNewExpressForm.form.valid && onSubmit()" novalidate>

    <div class="row">
        <!-- Contract -->
        <div class="col">
            <div class="form-group">
              
                <select class="form-control" required [(ngModel)]="contract" name="contract" #Erequest="ngModel">
                    <option value="">--Select Request--</option>
                    <option *ngFor="let request of Contracts" [ngValue]="request">{{request.reference}} </option>
                </select>
                <p *ngIf="ngNewExpressForm.submitted && Erequest.errors" style="color: red;">
                    Please select associated request form
                </p>

            </div>
        </div>

     

      
    </div>
    <div class="row">
        <!-- Comment  -->
        <div class="col">
          <div class="form-group">
            <label for="exampleTextarea1">Comment</label>
            <textarea class="form-control" id="description" rows="4" name="comment" [(ngModel)]="comment"
              required #Edescription="ngModel"></textarea>

            <div class="alert alert-danger" role="alert" *ngIf="ngNewExpressForm.submitted && Edescription.errors">
              Comment is required!
            </div>
          </div>
        </div>

        

       
      </div>
      <div class="form-group">
        <button type="submit" class="btn btn-success">Submit</button>
    </div>
</form>

    </div>
</div>


    </div>
</div>
<!-- Request Summary  -->
<div class="card" *ngIf="contract">
    <div class="card-body">
        <div class="card-title">
            <h4 class="card-title">Request Summary</h4>
        </div>

        <div class="row">

            <div class="col">
                <div class="form-group">
                    <label><b>Request Reference</b></label>
                    <p>{{ contract?.reference }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>Function</b></label>
                    <p>{{ contract?.departmentName }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>Location</b></label>
                    <p>{{ contract?.locationName }}</p>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col">
                <div class="form-group">
                    <label><b>Cost Center</b></label>
                    <p>{{ contract?.costCenterName }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>Request Date</b></label>
                    <p>{{ contract?.createdDate | date: 'dd MMMM yyyy' }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>Contract Duration (Month)</b></label>
                    <p>{{ contract?.contractDuration }}</p>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col">
                <div class="form-group">
                    <label><b>Expected Start Date</b></label>
                    <p>{{ contract?.expectedStartDate | date: 'dd MMMM yyyy' }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>Number of Staff</b></label>
                    <p>{{ contract?.noOfStaff }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>Approved Cost</b></label>
                    <p>{{ contract?.approvedCost }}</p>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col">
                <div class="form-group">
                    <label><b>Requested By</b></label>
                    <p>{{ contract?.createdBy }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>Contractor</b></label>
                    <p>{{ contract?.contractorName }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>PO Number</b></label>
                    <p>{{ contract?.poNumber }}</p>
                </div>
            </div>
        </div>

        <div class="row">

            <div class="col">
                <div class="form-group">
                    <label><b>Request Description</b></label>
                    <p>{{ contract?.description }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>Request Justification</b></label>
                    <p>{{ contract?.justification }}</p>
                </div>
            </div>

            <div class="col">
                <div class="form-group">
                    <label><b>Required Qualification & Experience</b></label>
                    <p>{{ contract?.qualification }}</p>
                </div>
            </div>
        </div>

      
    </div>

</div>
<!-- Request Summary  -->
</div>
